import { Injectable } from '@angular/core';
import { HIPInsuredPersonFromHIPDto } from 'src/app/modules/_services/api/@generated/models';
import { HIPContractDto } from 'src/app/modules/_services/api/@generated/models';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { CookieOptions , CookieService} from 'ngx-cookie-service';
import { APIClient } from '@pbo-api';

@Injectable({
  providedIn: 'root'
})

export class DataService {

  public availableYears = [];
  public fixInfoContainerHeight = 124;

  public hasEnglishVersion = false;
  public selectedLanguage = 'hu';

  private cookieOptions: CookieOptions = {
    expires: 3,
    path: '/',
    secure: true
  };

  constructor(private translate: TranslateService,
              private cookie: CookieService,
              private api: APIClient,
              private titleService: Title) {
//    this.translate.setDefaultLang(this.selectedLanguage);
//    if (!this.cookie.get('language')) {
//      this.cookie.set('language', this.selectedLanguage, this.cookieOptions);
//    }

    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i >= 1940; i--) {
      this.availableYears.push(i);
    }
  }

  HIPInsuredPersonFromHIPDto: HIPInsuredPersonFromHIPDto;
  HIPContractDto: HIPContractDto;
  connectionLinkType: string = null;

  _dataLocation: string;

  updateUserData(data: any) {
    if(typeof data === 'string') {
      this._dataLocation = data;
      return
    }

    if(this._dataLocation === 'interruptionId') this.HIPInsuredPersonFromHIPDto = data;
    if(this._dataLocation === 'riskStartDate') this.HIPInsuredPersonFromHIPDto = data;
    if(this._dataLocation === 'offer') this.HIPInsuredPersonFromHIPDto = data;
    if(this._dataLocation === 'employee') this.HIPInsuredPersonFromHIPDto.employee = data;
    if (this._dataLocation === 'insuredPerson') {
      // ezeket itt nagyon-nagyon refaktorálni kellene!!! :(
      this.HIPInsuredPersonFromHIPDto.insuredPerson = data.insuredPerson;
      this.HIPInsuredPersonFromHIPDto.legalGuardian = data.legalGuardian;
    }
    if (this._dataLocation === 'contactInfo') {
      this.HIPInsuredPersonFromHIPDto.insuredPerson = data;
    }
    if(this._dataLocation === 'socsecNumber') this.HIPInsuredPersonFromHIPDto.insuredPerson = data;
    if(this._dataLocation === 'payFrequency') { this.HIPInsuredPersonFromHIPDto.paymentFrequency = data.paymentFrequency; this.HIPInsuredPersonFromHIPDto.paymentType = 'KB'; }

    this.connectionLinkType? this.HIPInsuredPersonFromHIPDto.linkType = this.connectionLinkType : null;
    sessionStorage.setItem('HIPInsuredPersonFromHIPDto', JSON.stringify(this.HIPInsuredPersonFromHIPDto));

    //console.log('-------------- DataService model updated: --------------')
    //console.log(this.HIPInsuredPersonFromHIPDto)

    //sessionStorage.clear(); // - to clear sessionStorage
  }

  public isKompakt(): boolean {
    return this.connectionLinkType === 'KOMPAKT_HOZZATARTOZOI' || this.connectionLinkType === 'KOMPAKT_PARTNERI';
  }

  public isPartneri(): boolean {
    return this.connectionLinkType === 'PARTNERI' || this.connectionLinkType === 'KOMPAKT_PARTNERI';
  }

  public setLanguage(language: string): void {
    const oldLang: string = this.selectedLanguage;
    if (oldLang !== language) {
      this.translate.use(language).subscribe(() => {
        const connectionKey: string = sessionStorage.getItem('connectionKey');
        if (connectionKey) {
          this.api.getPassiveContract({connectionKey})
            .subscribe((rs) => {
              sessionStorage.setItem('HIPContract', JSON.stringify(rs));
              this.updateLanguage(language);
            });
        }
      });
    }
  }

  private updateLanguage(language): void {
    this.selectedLanguage = language;
//    this.cookie.set('language', this.selectedLanguage, this.cookieOptions);
    sessionStorage.setItem('selectedLanguage', this.selectedLanguage);
    this.setPageTitle();
  }

  public setPageTitle(): void {
    const title = this.isKompakt() ? 'dropDown.title.kompakt' : 'dropDown.title.notKompakt';
    this.translate.get(title).subscribe((val) => {
      this.titleService.setTitle(val);
    });
  }

  public getTitleList(): string[] {
    return this.selectedLanguage === 'en' ?
      [
        'Dr.',
        'Dr. Dr.',
        'Dr. Prof.',
        'Ing.',
        'MBA',
        'Prof.',
        'Prof. Dr.'
      ] :
      [
        'Dr.',
        'Dr. Dr.',
        'Dr. Id.',
        'Dr. Ifj.',
        'Dr. Özv.',
        'Dr. Prof.',
        'Id.',
        'Id. Dr.',
        'Id. Özv.',
        'Id. Prof.',
        'Ifj.',
        'Ifj. Dr.',
        'Ifj. Özv.',
        'Ifj. Prof.',
        'Ing.',
        'MBA',
        'Özv.',
        'Özv. Dr.',
        'Özv. Id.',
        'Özv. Ifj.',
        'Özv. Prof.',
        'Prof.',
        'Prof. Dr.',
        'Prof. Id.',
        'Prof. Ifj.',
        'Prof. Özv.'
      ];
  }

}
